'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

require('./IndexHeroLandscape.less');

module.exports = Backbone.View.extend({

    el: '.IndexHeroLandscape',

    PARALLAX_STRENGTH: 5,
    PARALLAX_SPEED: 0.3,

    initialize: function () {
        _.bindAll(this, 'onMouseMove');

        this.heroBackText = this.$('.heroBackText')[0];

        this.targetX = 0;
        this.targetY = 0;
        this.currentX = 0;
        this.currentY = 0;

        if (window.app.isPointer) {
            document.addEventListener('mousemove', this.onMouseMove);
            this.animate();
        }
    },

    onMouseMove: function (event) {
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        const offsetX = (event.clientX - centerX) / centerX;
        const offsetY = (event.clientY - centerY) / centerY;

        this.targetX = offsetX * this.PARALLAX_STRENGTH;
        this.targetY = offsetY * this.PARALLAX_STRENGTH;
    },

    animate: function () {
        this.currentX += (this.targetX - this.currentX) * this.PARALLAX_SPEED;
        this.currentY += (this.targetY - this.currentY) * this.PARALLAX_SPEED;

        this.heroBackText.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`;

        requestAnimationFrame(() => this.animate());
    }
});
